import React from 'react';
import CountUp, { startAnimation } from 'react-countup';
import Waypoint from 'react-waypoint';
import LazyLoadTransition from '../../components/LazyLoadTransition/LazyLoadTransition';
import './About.scss';
import { FIRST_DAY, LAST_DAY, YEAR } from '../../constants';

const START_TIME = 0;
const DURATION_TIME = 3;

const stats = {
  days: 2,
  speakers: 63,
  presentations: 40,
  labs: 12,
  attendees: 1170
  // viewers: 3600
};

const about = () => {
  let animationStarted = false;
  let days;
  let speakers;
  let presentations;
  let labs;
  let attendees;
  // let viewers;

  const startCounter = () => {
    if (!animationStarted) {
      startAnimation(days);
      startAnimation(speakers);
      startAnimation(presentations);
      startAnimation(labs);
      startAnimation(attendees);
      // startAnimation(viewers);
      animationStarted = true;
    }
  };

  return (
    <>
      {/* <div className="about-background" /> */}
      {/* <div id="note">
        <h1>
          We’re very sorry but the registration to OpenSlava {YEAR} is currently unavailable. We’re
          working hard to have it fixed as soon as possible. Please come back later.
        </h1>
      </div> */}
      {/* <div className="save-the-date section">
        <h1>Save the date October 18-19, 2023</h1>
        <h1> and stay tuned for more details</h1>
      </div> */}
      {/* <div className="save-the-date section">
        <p>
          <span>Registration for OpenSlava 2023 is currently at full capacity. </span> */}
      {/* However, we encourage you to join the waiting list. In the event that we are unable to
          accommodate your request for onsite attendance, we will provide you with a link for online
          streaming at a later time. */}
      {/* </p>
      </div> */}
      <section className="section" id="about">
        <div className="container">
          <h1>ABOUT</h1>
          <div className="columns is-variable is-desktop is-multiline is-centered is-mobile">
            <div className="column is-6-desktop is-12-tablet is-12-mobile">
              <p>
                OpenSlava {YEAR} is the 11th edition of a successful annual IT conference focused on
                open source and emerging digital technologies, organized by Accenture in Slovakia.
              </p>
              <div className="as-paragraph">
                OpenSlava {YEAR} will be organized as a 2-day conference:
                <br />
                <strong>
                  <span>
                    Day 1, October {FIRST_DAY}, {YEAR}: Hands-on Labs day
                  </span>
                </strong>
                <ul>
                  <li>
                    Series of 3-hour interactive, deep dive workshops for smaller groups of 20-30
                    participants
                  </li>
                </ul>
                <strong>
                  <span>
                    Day 2, October {LAST_DAY}, {YEAR}: Main conference day
                  </span>
                </strong>
                <ul>
                  <li>
                    Keynotes, discussions and presentations centered around the latest tech trends
                    and innovations
                  </li>
                  <li>Exhibition area and networking opportunities</li>
                  {/* <li>
                    Leitmotiv of the conference will be “Uniting Technology and Sustainability”
                  </li> */}
                </ul>
              </div>
              <div className="as-paragraph">
                <strong>
                  <span>OpenSlava {YEAR}: Embracing this exciting era of generative AI</span>
                </strong>
                <p>
                  Join us on October {FIRST_DAY}-{LAST_DAY}, {YEAR} and enjoy the presentations,
                  workshops and discussions reflecting the arrival of foundation models, which are
                  claimed to be one of the biggest changes in AI history. No enterprise can ignore
                  them anymore. Already, companies can use models available today to experiment and
                  build novel applications; as the technology advances, the opportunities will only
                  multiply. Whether you are a seasoned professional, a student eager to learn, a
                  university teacher seeking inspiration, or a consultant looking for fresh
                  perspectives, there is something for every IT enthusiast on OpenSlava. The
                  exploration of AI will extend this year to a diverse range of topics, including
                  cloud technologies, digital identity, security, and more.
                </p>
              </div>
              <div className="as-paragraph">
                <strong>
                  <span>Format of the conference</span>
                </strong>
                <p>Hybrid combining in-person conference with online streaming</p>
              </div>
              <div className="as-paragraph">
                <strong>
                  <span>Consider attending OpenSlava {YEAR} if you are:</span>
                </strong>
                <ul>
                  <li>Technology architect or Developer</li>
                  <li>IT consultant</li>
                  <li>IT student and teachers from IT faculties/universities</li>
                  <li>
                    IT enthusiast interested in innovations, latest trends in open source and
                    emerging digital technologies
                  </li>
                </ul>
              </div>
              <p>
                As we want our OpenSlava community to further grow and keep it open for everyone,
                the registration to the conference will remain <strong>free of charge</strong>.
                {/* However, please note that capacity is limited, so secure your spot by{' '}
                <a
                  href="https://cvent.me/Bd0QMW?RefId=Registration"
                  rel="noopener noreferrer"
                  target="_blank">
                  registering now
                </a>
                . */}
              </p>
              {/* <p> */}
              {/* We would like to inform you that
                <strong> OpenSlava 2023 registration has reached its maximum capacity </strong>
                at this time. */}
              {/* We invite you to consider joining the waiting list by accessing the
                registration link provided above. If we are unable to accommodate your request for
                onsite attendance, we will ensure that you receive a link for online streaming at a
                later point. */}
              {/* </p> */}
              <p>
                Over the years OpenSlava evolved into an international event attended by{' '}
                <strong>top speakers</strong> and participants from all around the globe, and
                therefore, the <strong>language of the conference is English</strong>.
              </p>
              <p>
                Do you want to learn more about the organizer? Visit{' '}
                <a
                  href="https://www.accenture.com/sk-sk/careers"
                  rel="noopener noreferrer"
                  target="_blank">
                  {' '}
                  www.accenture.sk
                </a>
                .
              </p>
            </div>
            <div className="column is-6-desktop is-12-tablet is-12-mobile" id="youtube-column">
              {/* <LazyLoadTransition> */}
              <div className="card">
                <iframe
                  allowFullScreen
                  src="https://www.youtube.com/embed/ZQuCteQI608?si=3nY_v6w_CGUZdnQV"
                  title="yt-video"
                  width="100%"
                />
                <footer className="footer-wrapper">
                  <strong>
                    <p className="card-footer-item">Aftermovie from OpenSlava {YEAR}</p>
                  </strong>
                </footer>
              </div>
              {/* </LazyLoadTransition> */}
            </div>
          </div>

          <LazyLoadTransition>
            <h1 className="section-title openslava-numbers is-hidden-mobile">
              {/* OpenSlava {LAST_YEAR} in numbers */}
              OpenSlava {YEAR} in numbers
            </h1>
            <Waypoint onEnter={startCounter} />
            <div className="columns is-variable is-desktop is-mobile is-multiline is-hidden-mobile is-centered">
              <div className="column is-1-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      days = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.days}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Days</div>
              </div>
              <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      speakers = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.speakers}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Speakers</div>
              </div>
              <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      presentations = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.presentations}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Presentations</div>
              </div>
              <div className="column is-2-desktop is-6-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      labs = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.labs}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Hands-on Labs</div>
              </div>
              <div className="column is-3-desktop is-6-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      attendees = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.attendees}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Onsite participants</div>
              </div>
              {/* <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      viewers = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.viewers}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Unique viewers</div>
              </div> */}
            </div>
          </LazyLoadTransition>
        </div>
      </section>
    </>
  );
};

export default about;
